import { useState } from 'react';
import { Box, Fab } from '@mui/material';
import ForumIcon from '@mui/icons-material/Forum';
import { colors } from 'styles/colors';
import { hexWithOpacity } from 'common/utils';
import DiscussionNotesModal from 'components/modals/DiscussionNotesModal/DiscussionNotesModal';

interface Props {
  procedureId: number;
  hasNotes?: boolean;
  refetch?: () => void;
}

export default function CaseNotesFab({ procedureId, hasNotes, refetch }: Props) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    refetch?.();
  };

  const bgColor = hasNotes ? colors.notes : hexWithOpacity(colors.primary, 0.5);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 44,
        right: 44,
        zIndex: 1300,
      }}
    >
      <Fab
        onClick={() => setOpen(true)}
        sx={{
          bgcolor: bgColor,
          color: colors.white,
          width: 56,
          height: 56,
          boxShadow: '0 4px 16px rgba(7,59,112,0.35)',
          '&:hover': {
            bgcolor: bgColor,
            opacity: 0.9,
            transform: 'scale(1.07)',
          },
          transition: 'transform 0.2s, background-color 0.2s',
        }}
      >
        <ForumIcon />
      </Fab>

      <DiscussionNotesModal
        open={open}
        onClose={handleClose}
        procedureId={procedureId}
      />
    </Box>
  );
}
